<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Edit Specification Update - {{version.name}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <i>Edit the settings for the specification update named <b>{{ version.name }}</b> located at path <b>{{ path }}</b>.</i>
        <div>
          <v-checkbox
            v-model="active"
            label="Active"
          >
          </v-checkbox>
          <v-select
            v-model="targetFamily"
            :items="targetFamilySelection"
            label="Target family"
            outlined
          >
          </v-select>
          <v-text-field
            v-model="filter"
            label="filter"
            outlined
            @input="validateFilter"
          >
          </v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="indigo" class="white--text" @click="onConfirmClick()" v-if="filterValid">Update</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    path: String,
    version: Object,
    prerequisites: Object,
    active: Boolean,
    targetFamily: String,
    filter: String,
  },

  data() {
    return {
      filterArray: ['*'],
      filterValid: true,
      targetFamilySelection: ['all', 'aligner', 'gtps'],
    };
  },

  methods: {
    onCancelClick() {
      this.path = '';
      this.version = {
        name: '',
      };
      this.targetFamily = 'all';
      this.filter = '*';
      this.filterArray = ['*'];
      this.filterValid = true;

      this.$emit('close', false);
    },

    onConfirmClick() {
      const options = {
        method: 'POST',
        url: '/update/spec_update/v1',
        data: {
          path: this.path,
          version: this.version,
          active: this.active,
          targetFamily: this.targetFamily,
          filter: this.filterArray,
        },
      };

      this.axios(options)
        .then(() => {
          this.path = '';
          this.version = {
            name: '',
          };
          this.targetFamily = 'all';
          this.filter = '*';
          this.filterArray = ['*'];
          this.filterValid = true;

          this.$emit('close', true);
        });
    },

    validateFilter() {
      if (this.filter.length > 0) {
        try {
          this.filterArray = this.filter.split(',');
          this.filterValid = true;
        } catch (err) {
          this.filterValid = false;
        }
      } else {
        this.filterValid = false;
      }
    },
  },
};
</script>
